import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, UserIcon, ArrowRightIcon } from 'lucide-react';
import { getRelatedArticles, Article } from '../../services/articles';
interface RelatedArticlesProps {
  article: Article;
  limit?: number;
}
const RelatedArticles: React.FC<RelatedArticlesProps> = ({
  article,
  limit = 3
}) => {
  const [relatedArticles, setRelatedArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchRelatedArticles = async () => {
      if (!article || !article.id) return;
      try {
        setLoading(true);
        const articles = await getRelatedArticles(article, limit);
        setRelatedArticles(articles);
      } catch (error) {
        console.error('Error fetching related articles:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchRelatedArticles();
  }, [article, limit]);
  // Format date
  const formatDate = (timestamp: any) => {
    if (!timestamp) return 'Date unavailable';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  if (loading) {
    return <div className="bg-gray-50 p-6 rounded-lg" data-id="element-76">
        <h3 className="text-xl font-bold text-navy mb-4 font-montserrat" data-id="element-77">
          Related Articles
        </h3>
        <div className="animate-pulse space-y-4" data-id="element-78">
          {[...Array(limit)].map((_, index) => <div key={index} className="flex space-x-4" data-id="element-79">
              <div className="h-14 w-14 bg-gray-300 rounded" data-id="element-80"></div>
              <div className="flex-1 space-y-2 py-1" data-id="element-81">
                <div className="h-4 bg-gray-300 rounded w-3/4" data-id="element-82"></div>
                <div className="h-3 bg-gray-300 rounded w-1/2" data-id="element-83"></div>
              </div>
            </div>)}
        </div>
      </div>;
  }
  if (relatedArticles.length === 0) {
    return <div className="bg-gray-50 p-6 rounded-lg" data-id="element-84">
        <h3 className="text-xl font-bold text-navy mb-4 font-montserrat" data-id="element-85">
          Related Articles
        </h3>
        <p className="text-gray-500 italic" data-id="element-86">No related articles found.</p>
      </div>;
  }
  return <div className="bg-gray-50 p-6 rounded-lg" data-id="element-87">
      <h3 className="text-xl font-bold text-navy mb-4 font-montserrat" data-id="element-88">
        Related Articles
      </h3>
      <div className="space-y-4" data-id="element-89">
        {relatedArticles.map(relatedArticle => <div key={relatedArticle.id} className="flex items-start border-b border-gray-200 pb-4 last:border-0 last:pb-0" data-id="element-90">
            {relatedArticle.featuredImage && <Link to={`/enews/${relatedArticle.id}`} className="shrink-0 mr-4" data-id="element-91">
                <img src={relatedArticle.featuredImage} alt={relatedArticle.title} className="w-16 h-16 object-cover rounded-md" data-id="element-92" />
              </Link>}
            <div className="flex-1 min-w-0" data-id="element-93">
              <h4 className="text-navy font-medium mb-1 line-clamp-2" data-id="element-94">
                <Link to={`/enews/${relatedArticle.id}`} className="hover:text-orange transition duration-300" data-id="element-95">
                  {relatedArticle.title}
                </Link>
              </h4>
              <div className="flex items-center text-xs text-gray-500 mb-1" data-id="element-96">
                <CalendarIcon size={12} className="mr-1" data-id="element-97" />
                <span data-id="element-98">{formatDate(relatedArticle.publishedAt)}</span>
                <span className="mx-2" data-id="element-99">•</span>
                <UserIcon size={12} className="mr-1" data-id="element-100" />
                <span data-id="element-101">{relatedArticle.author.name}</span>
              </div>
              <Link to={`/enews/${relatedArticle.id}`} className="text-sm text-orange hover:underline flex items-center" data-id="element-102">
                Read article <ArrowRightIcon size={14} className="ml-1" data-id="element-103" />
              </Link>
            </div>
          </div>)}
      </div>
    </div>;
};
export default RelatedArticles;